
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Box, Divider, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";
import RectangleIcon from "@mui/icons-material/Rectangle";

const ArcLegendRYGG = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label, Color, Proportion, DataLabels } = ComponentProperties
    const DataLabelArray = DataLabels ? DataLabels.split('|') : []

    // KeyToUse will be an array

    return (
        <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
            <Grid item xs={12} md={3}>
                <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
                    <Grid item xs={3} justifyContent="end">
                        <Typography align="right">
                            <RectangleIcon fontSize='medium' sx={{ color: GetColor('RYGG VALUE GRADE',1) }} />
                        </Typography>
                    </Grid>
                    <Grid item xs={9} justifyContent="start">
                        <Typography variant="caption" align="left">{DataLabelArray[0]}</Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} md={3}>
                <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
                    <Grid item xs={3} justifyContent="end">
                        <Typography align="right">
                            <RectangleIcon fontSize='medium' sx={{ color: GetColor('RYGG VALUE GRADE',2) }} />
                        </Typography>
                    </Grid>
                    <Grid item xs={9} justifyContent="start">
                        <Typography variant="caption" align="left">{DataLabelArray[1]}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={3}>
                <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
                    <Grid item xs={3} justifyContent="end">
                        <Typography align="right">
                            <RectangleIcon fontSize='medium' sx={{ color: GetColor('RYGG VALUE GRADE',3) }} />
                        </Typography>
                    </Grid>
                    <Grid item xs={9} justifyContent="start">
                        <Typography variant="caption" align="left">{DataLabelArray[2]}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={3}>
                <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
                    <Grid item xs={3} justifyContent="end">
                        <Typography align="right">
                            <RectangleIcon fontSize='medium' sx={{ color: GetColor('RYGG VALUE GRADE',0) }} />
                        </Typography>
                    </Grid>
                    <Grid item xs={9} justifyContent="start">
                        <Typography variant="caption" align="left">{DataLabelArray[3]}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ArcLegendRYGG